/** 그림자·모서리·모션 — 프리미엄 UI 토큰 */
export type EffectsTypes = typeof effects;

export const effects = {
	radiusSm: '0.8rem',
	radiusMd: '1.2rem',
	radiusLg: '1.6rem',
	radiusXl: '2rem',
	radiusFull: '9999px',
	shadowSm: '0 1px 2px rgba(0, 21, 52, 0.04), 0 2px 8px rgba(0, 21, 52, 0.06)',
	shadowMd: '0 4px 20px rgba(0, 21, 52, 0.08), 0 2px 8px rgba(0, 21, 52, 0.04)',
	shadowLg: '0 12px 48px rgba(0, 21, 52, 0.12), 0 4px 16px rgba(0, 21, 52, 0.06)',
	shadowHeader: '0 4px 24px rgba(0, 21, 52, 0.08)',
	transitionFast: '0.15s cubic-bezier(0.4, 0, 0.2, 1)',
	transitionBase: '0.25s cubic-bezier(0.4, 0, 0.2, 1)',
	transitionSlow: '0.4s cubic-bezier(0.4, 0, 0.2, 1)',
} as const;
